import { TaxonomyMasterPage } from "@/components/taxonomy-master-page";

export default function Stacks() {
  return (
    <TaxonomyMasterPage
      kind="stack"
      title="Stacks"
      hint="A hard gate — every question's stack_path must resolve to one of these, at ingest, enrichment, and review."
    />
  );
}
